import {Routes} from '@angular/router';

export const serviceManagementRoutes: Routes = [
  {
    path: 'serviceManagement',
    data: { title: '服务项目管理' },
    children: [
      {
        path: '',
        loadComponent: () => import('./service-management.component').then(m => m.ServiceManagementComponent),
        data: { title: '服务项目管理' },
      },
      {
        path: 'addRelease',
        loadComponent: () => import('./add-service-item/add-service-item.component').then(m => m.AddServiceItemComponent),
        data: { title: '添加服务项目' },
      },
      {
        path: 'addRelease/:releaseId',
        loadComponent: () => import('./add-service-item/add-service-item.component').then(m => m.AddServiceItemComponent),
        data: { title: '添加服务上架' },
      }
    ]
  },
];
